import { TermViewModel } from "../SearchPage/SearchPage.types";

export interface ISearchListProps {
  categoryFilter: CategoryItem[];
  searchCategories?: TermCount[];
  initalSearchResultModel: SearchResultModel;
  searchresultHeading: string;
  searchPageLink: string;
  pageSize: number;
  currentPageId: number;
  useFacets?: boolean;
}

export interface CategoryItem {
  Id: number;
  Name: string;
  Category: CategoryType;
}

export enum CategoryType {
  Mandatory,
  Product,
}

export interface ISearchListState {
  relevansbuttonIsActive: boolean;
  sortbuttonIsActive: boolean;
  amneopen: boolean;
  productopen: boolean;
  filteropen: boolean;
  currentSearchState: SearchModel;
  isSearching: boolean;
  searchResultModel: SearchResultModel;
  isDataLoading: boolean;
  isError: boolean;
}

export interface SearchModel {
  PageNo: number; //defaults to 1 on initial rendering
  Query: string;
  MandatoryCategories: number[]; //defaults to empty array on initial rendering
  StandardCategories: number[]; //defaults to empty array on initial rendering
  IsDocument: boolean;
  SearchCategories: string[];
  //the following comes with the initial rendering an never changes
  PageSize: number;
  CurrentPageId: number;
  SortBy: SortType;
}

export enum SortType {
  Relevance,
  Date,
  Ascending,
  Descending,
}

export interface SearchResultModel {
  DidYouMean: DidYouMean[];
  ResultItems: ResultItem[];
  ExternalBestBets: ResultItem[];
  TotalHits: number;
  Query: string;
  SearchSubjectsResult: TermViewModel[];
  SearchContentTypeResult: TermViewModel[];
  SearchGlobalSubjectsResult?: TermViewModel[];
  SearchGlobalContentTypesResult?: TermViewModel[];
  SearchTabsResult?: TermViewModel[];
  SearchFileExtensionsResult?: TermViewModel[];
  SearchBusinessAreasResult?: TermViewModel[];
}

export interface ResultItem {
  Id: string;
  Url: string;
  Title: string;
  Startdate: string;
  Text: string;
  Maintext: string;
  CategoryList: string[];
  ItemType: string;
  Type: string;
  DateClassModifier: string;
  StartPageExternalUrl: string;
  StartPageName: string;
  SharePointFileExtensionClass: string;
  SearchResultsBreadCrumbs: SearchResultsBreadCrumbs[];
  BestBetsExternalLink: boolean;
  ShoppingAdressUrl: string;
  CanShop: boolean;
  Tag: string;
  BilagaDocuments: ResultItem[];
  IsBilaga: boolean;
  PortfolioId: string;
  HasMainDocument: boolean;
  HighlightedWord: string;
  HighlightedTitle: string;
  HighlightedWordList: string[];
}
export interface SearchResultsBreadCrumbs {
  Name: string;
  Url: string;
}

export interface DidYouMean {
  Name: string;
}
export interface TermCount {
  Term: string;
  Count: number;
}
